// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__1UVFK","time":"styles_time__3S9FG"};